module.exports = "/images/demo_time_sampling.png?623cfe26b0218df5d9b1998093548483";